import React from 'react';
import PropTypes from 'prop-types';

import { transformConcessionToTextList } from 'common/concessionHelpers';

import { formatPrice } from 'common/formatters';

import SrMarkdown, { SR_MARKDOWN_THEME_CALL_SCRIPT } from 'client/components/SrMarkdown';

import SrBox from 'client/components/SrBox';

import './HitlistTaskListRow.less';

const makeConcessionMarkdown = ({ concession, listing }) => {
  if (!concession || !listing) {
    return '';
  }
  const concessionTextList = transformConcessionToTextList({
    concession,
    rentPrice: listing.price,
  });
  return [
    '\n',
    '## Special Concession on this listing!',
    `Concession amount: ${formatPrice(concession.amount)}`,
    ...concessionTextList,
  ].join('\n');
};

const HitlistTaskListRowCallScript = ({ hitlistTask, hitlistCallScripts, listing, concession }) => {
  const callScript = hitlistCallScripts[hitlistTask.type];
  if (!callScript) {
    return null;
  }
  return (
    <div styleName="section">
      <span styleName="title">Call Script</span>
      <SrBox backgroundColor="#FFFBEB" padding="6px 6px 12px" borderRadius="6px">
        <SrMarkdown
          source={`${callScript}${makeConcessionMarkdown({ concession, listing })}`}
          theme={SR_MARKDOWN_THEME_CALL_SCRIPT}
        />
      </SrBox>
    </div>
  );
};

HitlistTaskListRowCallScript.propTypes = {
  hitlistTask: PropTypes.object.isRequired,
  hitlistCallScripts: PropTypes.object.isRequired,
  concession: PropTypes.object,
  listing: PropTypes.object,
};

HitlistTaskListRowCallScript.displayName = 'HitlistTaskListRowCallScript';

export default HitlistTaskListRowCallScript;
